<template>
  <li class="row-content">
    <div class="t-sm d-flex">
      <span class="t-600">{{'Sponsor' | pluralize(sponsors.length)}}:</span>
      <span class="ml-1 t-overflow">{{ sponsors | separateByComma('name')}}</span>
    </div>
  </li>
</template>

<script>
export default {
  name: 'searchResultPartialSponsors',
  props: {
    sponsors: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
